import React from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import forms from 'constants/forms';
import Input from 'components/atoms/input';

const Info = ({ errors, disabledFields }) => {
  const personalInfo = [...forms.adminPanelAgencyDoctor.userEdit.personalInfo];
  return (
    <div className="admin-agent-form-block">
      <span>Personal Info</span>
      <Row>
        {personalInfo.map((field) => (
          <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
            <Input {...field} disabled={disabledFields.includes(field.id)} />
            {errors[field.id] ? (
              <div className="input-error">
                {errors[field.id].split('.')[0]}
              </div>
            ) : null}
          </Col>
        ))}
      </Row>
    </div>
  );
};

Info.defaultProps = {
  disabledFields: [],
};

Info.propTypes = {
  errors: PropTypes.shape({}).isRequired,
  disabledFields: PropTypes.array,
};

export default Info;
